export default "__VITE_ASSET__3ed22fdf__"